export const ENV = {
  API_URL: 'https://planora-api.skozub.pl',
  IDENTITY_URL: 'https://auth.skozub.pl',
  WS_URL: 'wss://planora-api.skozub.pl',
}
